'use client'

import { useState } from 'react'
import { Button } from '@planner/ui'
import { useAuth } from '@/contexts/AuthContext'

export function ImpersonationBanner() {
  const { isImpersonating, impersonatedFromEmail, stopImpersonation } = useAuth()
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  if (!isImpersonating) return null

  const handleStop = async () => {
    setLoading(true)
    setError(null)
    const result = await stopImpersonation()
    if (result.error) {
      setError(result.error)
    }
    setLoading(false)
  }

  return (
    <div className="w-full bg-amber-50 border-b border-amber-200 text-amber-900 px-4 py-2 text-sm flex items-center justify-between gap-3">
      <div className="truncate">
        Tryb impersonacji aktywny
        {impersonatedFromEmail ? ` (Super Admin: ${impersonatedFromEmail})` : ''}
      </div>
      <div className="flex items-center gap-2">
        {error && <span className="text-xs text-destructive">{error}</span>}
        <Button size="sm" variant="outline" onClick={handleStop} disabled={loading}>
          {loading ? 'Przywracanie...' : 'Wróć do Super Admina'}
        </Button>
      </div>
    </div>
  )
}
